
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
components: {
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
XButton,
Group,
XInput,
XTextarea,
XHeader,
Cell,
Toast
},
mounted(){
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
let id=this.$route.query.id;
let type=this.$route.query.type;
if(type==0){
this.TypeName="投诉商家";
}
else if(type==1){
this.TypeName="投诉买家";
}
this.complaintDetail=this.GLOBAL.currentObjs[id];
if(this.complaintDetail.AttachInfos!=null){
if(this.complaintDetail.AttachInfos.length==0){
this.imgUrl.push({
url: '/ShowImgPage?path=',//this.GLOBAL.noPicUrl,
img: this.GLOBAL.noPicUrl,
fallbackImg: this.GLOBAL.noPicUrl,
title: '暂无附件图片'});
}
else{
let index=1;
this.complaintDetail.AttachInfos.forEach(element => {
this.imgUrl.push({
url: '/ShowImgPage?path='+element.Path.replace("\\","/"),//process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
img: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
fallbackImg: process.env.BASE_URL.replace("api/", "")+element.Path.replace("\\","/"),
title: '资质图片'+index
});
index++;
});
}
}
this.getBusinessInfo();
},
methods: {
Save(status){
this.complaintDetail.Status=status;
post('/complaintinfo/update', this.complaintDetail).then(response => {

if(response.code==1){
this.showSuccess=true;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
getBusinessInfo(){
post('/Business/query', {GetCredential:0}).then(response => {
if(response.code==1){
response.data.forEach(element => {


if(this.complaintDetail!=null){
if(element.BusinessGuid==this.complaintDetail.ObjGuid){
this.complaintDetail.ObjZH=element.BusinessName;
}
}
});
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
console.log(error);
});
},
},
data () {
return {
complaintDetail:{
attachGuids:[],
ObjZH:'',
Title:'',
Content:'',
ComplaintDate:dateFormat(new Date(), 'YYYY年MM月DD日 HH时mm分')
},
imgUrl:[],
TypeName:'',
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'审核成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!'
}
}
}



// WEBPACK FOOTER //
// ./src/components/ManagerModules/ComplaintDetail.vue